import { fetchAuctionItems } from './auctionItemsActions';
import { fetchSaleItems } from './saleItemsActions';

export const fetchMarketItems = () => async (dispatch, getState) => {
  dispatch(fetchAuctionItems());
  dispatch(fetchSaleItems());
}



// WEBPACK FOOTER //
// ./src/redux/actions/marketItemsActions.js